import ActivityEntity from '../entities/Activity';

export type State = ActivityEntity[];

const initialState: State = [];

const Activity = (state: State = initialState, action: any) => {
  switch (action.type) {
    case 'SUCCESS_READ_ACTIVITIES_RECENT':
      return Array.from(new Set([...state, ...action.activities]));
  }

  return state;
};

export default Activity;



// WEBPACK FOOTER //
// ./src/reducers/Activity.ts